import { WestpacRedirectParameters } from '../api/types'

function redirectToWestpac({
    token,
    formUrl,
    communityCode,
    customerReferenceNumber
}: WestpacRedirectParameters): void {
    if (!token || !formUrl || !communityCode || !customerReferenceNumber) {
    throw new Error("Missing required parameters for Westpac payment submission.");
    }

    const form = document.createElement("form");
    form.method = "POST";
    form.action = formUrl;
    form.name = "westpacPaymentForm";

    const fields: Record<string, string> = {
    token,
    communityCode,
    };

    Object.entries(fields).forEach(([name, value]) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value ?? "";
    form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
}

export { redirectToWestpac }